import { render, staticRenderFns } from "./CoLabel.vue?vue&type=template&id=de8538d0&scoped=true&"
import script from "./CoLabel.vue?vue&type=script&lang=ts&"
export * from "./CoLabel.vue?vue&type=script&lang=ts&"
import style0 from "./CoLabel.vue?vue&type=style&index=0&id=de8538d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8538d0",
  null
  
)

export default component.exports